export const virtualSportApprovalStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const virtualSportApprovalStatusLabel = {
  [virtualSportApprovalStatus.PENDING]: "รอการตรวจสอบ",
  [virtualSportApprovalStatus.APPROVED]: "อนุมัติ",
  [virtualSportApprovalStatus.REJECTED]: "ไม่อนุมัติ",
};

export const virtualSportRejectionReason = {
  BLURRY_IMAGE: "รูปภาพไม่ชัด",
  NON_PROJECT_EQUIPMENT: "ไม่ใช่เครื่องออกกำลังกายในโครงการ",
  INVALID_WORKOUT: "ไม่ใช่กิจกรรมที่เข้าร่วม",
  RESUBMISSION: "ทำรายการซ้ำ",
  OTHER: "อื่นๆ",
};

export const virtualSportCaloriesPerStar = 10;
